import { Component, Input, ViewChild } from '@angular/core';
import { IonicSlides } from '@ionic/angular';
import * as moment from 'moment';


@Component({
    selector: 'TimePicker',
    templateUrl: './timePicker.component.html',
    styleUrls: ['./timePicker.component.scss'],
})
export class TimePicker{
    @Input() number;
    @Input() from;
    @Input() to;
    @Input() format;
    @Input() disabled = false;

    @ViewChild('slider0') slides0: typeof IonicSlides;
    @ViewChild('slider1') slides1: typeof IonicSlides;
    @ViewChild('slider2') slides2: typeof IonicSlides;
    @ViewChild('slider3') slides3: typeof IonicSlides;
    @ViewChild('slider4') slides4: typeof IonicSlides;
    @ViewChild('slider5') slides5: typeof IonicSlides;
    
    h0 = 0; m0 = true; h1 = 0; m1 = true; focusedElem = 0;
    time = '00:00';
    slideOpts: any[];
    ngOnInit(){
        this.slideOpts = new Array();
        for(let i=0; i<6; i++){
            this.slideOpts.push({
                centeredSlides: true,
                slidesPerView: 5,
                initialSlide: 0,
                direction: 'vertical',
                loop: true
            });
        }
        this.initialize();
        //(<HTMLInputElement>document.getElementById('slidesRow')).style.height = '100';
        (<HTMLInputElement>document.getElementById('slidesRow')).style.height = '0';
    }
    
    constructor(
    ) { 
        this.addMoreItems();
        this.addMoreItems2();
        this.addMoreItems3();
    }

    disabledPicker(value: boolean){
        this.disabled = value;
        // this.slides0.slideTo(0+5,0,false);
        // this.slides1.slideTo(0+4,0,false);
        // this.slides2.slideTo(0+5,0,false);
        // this.slides3.slideTo(0+5,0,false);
        // this.slides4.slideTo(0+4,0,false);
        // this.slides5.slideTo(0+5,0,false);
        (<HTMLInputElement>document.getElementById('24h'+0)).value = "12";
        (<HTMLInputElement>document.getElementById('24m'+0)).value = "00";
        (<HTMLInputElement>document.getElementById('AMPM'+0)).value = 'AM';
        (<HTMLInputElement>document.getElementById('24h'+1)).value = "12";
        (<HTMLInputElement>document.getElementById('24m'+1)).value = "00";
        (<HTMLInputElement>document.getElementById('AMPM'+1)).value = 'AM';

        for(var i=2; i<=9; i++) (<HTMLInputElement>document.getElementById('hidden_div'+i)).style.visibility = 'hidden';
        (<HTMLInputElement>document.getElementById('slidesRow')).style.height = '0';
        (<HTMLInputElement>document.getElementById('slidesRow')).style.height = 'calc(100%-100px)';

        this.from = new Date(this.year0+','+this.month0+','+this.day0+','+'00:00');
        this.to = new Date(this.year1+','+this.month1+','+this.day1+','+'00:00');
    }

    year0; year1; month0; month1; day0; day1; 
    initialize(){
        if(this.format != 12 && this.format != 24) this.format = 12; //default value
        (<HTMLInputElement>document.getElementById('selH')).value = this.format;
        var deviceValue = parseInt((<HTMLInputElement>document.getElementById('selH')).value);

        let date0 = new Date(this.from);
        this.year0 = date0.getFullYear(); this.month0 = date0.getMonth()+1; this.day0 = date0.getDay();
        (<HTMLInputElement>document.getElementById('24h'+0)).value = isNaN(parseInt(date0.getHours().toString())) ? '00' : date0.getHours().toString();
        (<HTMLInputElement>document.getElementById('24m'+0)).value = isNaN(parseInt(date0.getMinutes().toString())) ? '00' : date0.getMinutes().toString();
        let date1 = new Date(this.to);
        this.year1 = date1.getFullYear(); this.month1 = date1.getMonth()+1; this.day1 = date1.getDay();
        (<HTMLInputElement>document.getElementById('24h'+1)).value = isNaN(parseInt(date1.getHours().toString())) ? '00' : date1.getHours().toString();
        (<HTMLInputElement>document.getElementById('24m'+1)).value = isNaN(parseInt(date1.getMinutes().toString())) ? '00' : date1.getMinutes().toString();
        for(let n=0; n<=1; n++){
            var elem = (<HTMLInputElement>document.getElementById('24h'+n)).value;
            var min = parseInt(elem);
            if(deviceValue == 12){ //from 24 to 12
                if(isNaN(min)) min = 0;
                if(min > 12){
                    min = min-12;
                    (<HTMLInputElement>document.getElementById('AMPM'+n)).value = 'PM';
                }
                if(min == 0) min = 12; //no 0 hour for AM/PM
                if(min < 10) elem = '0'+min.toString();
                else elem = min.toString();
                if(min==0) elem='12';
                (<HTMLInputElement>document.getElementById('24h'+n)).value = elem;
                (<HTMLInputElement>document.getElementById('hidden_div'+n)).style.display = 'block';
            }else{ //from 12 to 24
                var AMPM = (<HTMLInputElement>document.getElementById('AMPM'+n)).value;
                if(AMPM == 'PM'){
                    min = min+12;
                    if(min==24) min = 12;
                }
                if(AMPM == 'AM' && min == 12) min = 0;

                if(min < 10) elem = '0'+min.toString();
                else elem = min.toString();
                (<HTMLInputElement>document.getElementById('24h'+n)).value = elem;
                (<HTMLInputElement>document.getElementById('hidden_div'+n)).style.display = 'none';
            }
        }
        for(var i=2; i<=9; i++) (<HTMLInputElement>document.getElementById('hidden_div'+i)).style.visibility = 'hidden';

        this.slideOpts[0].initialSlide = parseInt((<HTMLInputElement>document.getElementById('24h'+0)).value);
        this.slideOpts[1].initialSlide = parseInt((<HTMLInputElement>document.getElementById('24h'+0)).value)%12-1;
        this.slideOpts[2].initialSlide = parseInt((<HTMLInputElement>document.getElementById('24m'+0)).value);
        this.slideOpts[3].initialSlide = parseInt((<HTMLInputElement>document.getElementById('24h'+1)).value);
        this.slideOpts[4].initialSlide = parseInt((<HTMLInputElement>document.getElementById('24h'+1)).value)%12-1;
        this.slideOpts[5].initialSlide = parseInt((<HTMLInputElement>document.getElementById('24m'+1)).value);

        this.handleSeparator(deviceValue);
    }

    onChange(deviceValue) {
        for(let n=0; n<=1; n++){
            var elem = (<HTMLInputElement>document.getElementById('24h'+n)).value;
            var min = parseInt(elem);
            if(deviceValue == 12){ //from 24 to 12
                if(isNaN(min)) min = 0;
                if(min >= 12){ 
                    min = min-12;
                    (<HTMLInputElement>document.getElementById('AMPM'+n)).value = 'PM';
                }
                if(min == 0) min = 12; //no 0 hour for AM/PM
                if(min < 10) elem = '0'+min.toString();
                else elem = min.toString();
                (<HTMLInputElement>document.getElementById('24h'+n)).value = elem;
                (<HTMLInputElement>document.getElementById('hidden_div'+n)).style.display = 'block';
                
                (<HTMLInputElement>document.getElementById('hidden_div2')).style.display = 'none';
                (<HTMLInputElement>document.getElementById('hidden_div3')).style.display = 'block';
                (<HTMLInputElement>document.getElementById('hidden_div4')).style.display = 'none';
                (<HTMLInputElement>document.getElementById('hidden_div5')).style.display = 'block';
            }else{ //from 12 to 24
                var AMPM = (<HTMLInputElement>document.getElementById('AMPM'+n)).value;
                if(AMPM == 'PM'){ 
                    min = min+12;
                    if(min==24) min = 12;
                }
                if(AMPM == 'AM' && min == 12) min = 0;
                if(min < 10) elem = '0'+min.toString();
                else elem = min.toString();
                (<HTMLInputElement>document.getElementById('24h'+n)).value = elem;
                (<HTMLInputElement>document.getElementById('hidden_div'+n)).style.display = 'none';

                (<HTMLInputElement>document.getElementById('hidden_div2')).style.display = 'block';
                (<HTMLInputElement>document.getElementById('hidden_div3')).style.display = 'none';
                (<HTMLInputElement>document.getElementById('hidden_div4')).style.display = 'block';
                (<HTMLInputElement>document.getElementById('hidden_div5')).style.display = 'none';
            }
        }
        if(this.focusedElem == 0){
            (<HTMLInputElement>document.getElementById('hidden_div2')).style.visibility = 'visible';
            (<HTMLInputElement>document.getElementById('hidden_div3')).style.visibility = 'visible';
        }else if(this.focusedElem == 1){
            (<HTMLInputElement>document.getElementById('hidden_div4')).style.visibility = 'visible';
            (<HTMLInputElement>document.getElementById('hidden_div5')).style.visibility = 'visible';
        }

        // this.slides0.slideTo((parseInt((<HTMLInputElement>document.getElementById('24h'+0)).value))%24+5,0,false);
        // this.slides1.slideTo((parseInt((<HTMLInputElement>document.getElementById('24h'+0)).value))%12+4,0,false);
        // this.slides3.slideTo((parseInt((<HTMLInputElement>document.getElementById('24h'+1)).value))%24+5,0,false);
        // this.slides4.slideTo((parseInt((<HTMLInputElement>document.getElementById('24h'+1)).value))%12+4,0,false);

        this.handleSeparator(deviceValue);  
    }

    handleSeparator(deviceValue){
        if(deviceValue == 24){
            (<HTMLInputElement>document.getElementById('separator_col')).setAttribute("style","width:0px");
            (<HTMLInputElement>document.getElementById('separator_col0')).setAttribute("style","width:10px");
            (<HTMLInputElement>document.getElementById('separator_col')).style.display = 'none';
            (<HTMLInputElement>document.getElementById('separator_col0')).style.display = 'block';
            (<HTMLInputElement>document.getElementById('hidden_div9')).style.left = '136px';

            (<HTMLInputElement>document.getElementById('separator_col1')).setAttribute("style","width:0px");
            (<HTMLInputElement>document.getElementById('separator_col1')).style.display = 'none';

            //(<HTMLInputElement>document.getElementById('separator_col2')).setAttribute("style","width:0px");
            //(<HTMLInputElement>document.getElementById('separator_col2')).style.display = 'none';
        }else if(deviceValue == 12){
            (<HTMLInputElement>document.getElementById('separator_col')).setAttribute("style","width:10px");
            (<HTMLInputElement>document.getElementById('separator_col0')).setAttribute("style","width:0px");
            (<HTMLInputElement>document.getElementById('separator_col')).style.display = 'block';
            (<HTMLInputElement>document.getElementById('separator_col0')).style.display = 'none';
            (<HTMLInputElement>document.getElementById('hidden_div9')).style.left = '186px';

            (<HTMLInputElement>document.getElementById('separator_col1')).setAttribute("style","width:50px");
            (<HTMLInputElement>document.getElementById('separator_col1')).style.display = 'block';

            //(<HTMLInputElement>document.getElementById('separator_col2')).setAttribute("style","width:10px");
            //(<HTMLInputElement>document.getElementById('separator_col2')).style.display = 'block';
        } 
    }

    changeAMPM(value, n){
        var hours = (<HTMLInputElement>document.getElementById('24h'+n)).value;
        var minutes = (<HTMLInputElement>document.getElementById('24m'+n)).value;
        var h = parseInt(hours);
        if(isNaN(h)) h = 0;
        
        if(h<10) hours = '0'+h.toString();
        else hours = h.toString();

        if(hours.length==2 && minutes.length==2) this.time = hours +':'+minutes;
        else if(hours.length==2) this.time = hours +':00';
        else if(minutes.length==2) this.time = '00:'+minutes;

        var AMPM = (<HTMLInputElement>document.getElementById('AMPM'+n)).value;
        this.time = this.time+' '+AMPM;
        this.time = this.convert24(this.time);
        (<HTMLInputElement>document.getElementById('24h'+n)).value = hours;
        this.setTime(n);
    }

    focusTime(n){
        (<HTMLInputElement>document.getElementById('slidesRow')).style.height = '100';
        (<HTMLInputElement>document.getElementById('slidesRow')).style.height = '100%';
        var sel = parseInt((<HTMLInputElement>document.getElementById('selH')).value);
        if(n==0){
            if(sel == 24) (<HTMLInputElement>document.getElementById('hidden_div2')).style.visibility = 'visible';
            if(sel == 12) (<HTMLInputElement>document.getElementById('hidden_div3')).style.visibility = 'visible';
            (<HTMLInputElement>document.getElementById('hidden_div6')).style.visibility = 'visible';
            (<HTMLInputElement>document.getElementById('hidden_div8')).style.visibility = 'visible';
            (<HTMLInputElement>document.getElementById('hidden_div4')).style.visibility = 'hidden';
            (<HTMLInputElement>document.getElementById('hidden_div5')).style.visibility = 'hidden';
            (<HTMLInputElement>document.getElementById('hidden_div7')).style.visibility = 'hidden';
            (<HTMLInputElement>document.getElementById('hidden_div9')).style.visibility = 'hidden';
        }else if(n==1){
            (<HTMLInputElement>document.getElementById('hidden_div2')).style.visibility = 'hidden';
            (<HTMLInputElement>document.getElementById('hidden_div3')).style.visibility = 'hidden';
            (<HTMLInputElement>document.getElementById('hidden_div6')).style.visibility = 'hidden';
            (<HTMLInputElement>document.getElementById('hidden_div8')).style.visibility = 'hidden';
            if(sel == 24) (<HTMLInputElement>document.getElementById('hidden_div4')).style.visibility = 'visible';
            if(sel == 12) (<HTMLInputElement>document.getElementById('hidden_div5')).style.visibility = 'visible';
            (<HTMLInputElement>document.getElementById('hidden_div7')).style.visibility = 'visible';
            (<HTMLInputElement>document.getElementById('hidden_div9')).style.visibility = 'visible';
        }
        this.focusedElem = n;
    }

    unfocusHours(n){
        var hours = (<HTMLInputElement>document.getElementById('24h'+n)).value;
        var sel = (<HTMLInputElement>document.getElementById('selH')).value;
        if(sel == '12' && parseInt(hours)==0) (<HTMLInputElement>document.getElementById('24h'+n)).value = '12';
    }

    elem0 = "00";
    caret0 = 0;
    keyTime(e, max, n){
        var id = '24m'+n;
        if(max == 3) id = '24h'+n; //hours

        //AM-PM or 24h
        var sel = (<HTMLInputElement>document.getElementById('selH')).value;
        if(sel == '12' && max == 3) max = 2;

        var caret = (<HTMLInputElement>document.getElementById(id)).selectionStart;
        var elem = (<HTMLInputElement>document.getElementById(id)).value;
        
        this.caret0 = caret;
        this.elem0 = elem;
        return true;
    }
    timeLength(max, n){
        var id = '24m'+n;
        if(max == 3) id = '24h'+n; //hours

        //AM-PM or 24h
        var sel = (<HTMLInputElement>document.getElementById('selH')).value;
        if(sel == '12' && max == 3) max = 2;

        var elem = (<HTMLInputElement>document.getElementById(id)).value;
        var ok = true;
        var newElem = parseInt(elem[this.caret0]);
        if(isNaN(newElem)) ok = false;
        var oldElem = parseInt(this.elem0);
        if(isNaN(oldElem)) oldElem = 0;
        var min = 0;
        if(ok == true){
            min = (oldElem * 10 + newElem)%100;
            if(max==3 && min>23) min=newElem;
            else if(max==2 && min>12) min=newElem;
            else if(max==6 && min>60) min=newElem;
        }else min = oldElem;
        if(isNaN(min)) min=0;
        if(min == 0 && max == 2) min = 12; //for AM/PM there is no 0 hour, just 12

        if(min < 10) elem="0"+min.toString();
        else elem=min.toString();
        (<HTMLInputElement>document.getElementById(id)).value = elem;

        // if(n==0){
        //     this.slides0.slideTo((parseInt((<HTMLInputElement>document.getElementById('24h'+0)).value))%24+5,0,false);
        //     this.slides1.slideTo((parseInt((<HTMLInputElement>document.getElementById('24h'+0)).value))%12+4,0,false);
        //     this.slides2.slideTo((parseInt((<HTMLInputElement>document.getElementById('24m'+0)).value))%60+5,0,false);
        // }else if(n==1){
        //     this.slides3.slideTo((parseInt((<HTMLInputElement>document.getElementById('24h'+1)).value))%24+5,0,false);
        //     this.slides4.slideTo((parseInt((<HTMLInputElement>document.getElementById('24h'+1)).value))%12+4,0,false);
        //     this.slides5.slideTo((parseInt((<HTMLInputElement>document.getElementById('24m'+1)).value))%60+5,0,false);
        // }

        var hours = (<HTMLInputElement>document.getElementById('24h'+n)).value;
        var minutes = (<HTMLInputElement>document.getElementById('24m'+n)).value;
        var AMPM = (<HTMLInputElement>document.getElementById('AMPM'+n)).value;
        if(hours.length==2 && minutes.length==2) this.time = hours +':'+minutes;
        else if(hours.length==2) this.time = hours +':00';
        else if(minutes.length==2) this.time = '00:'+minutes;
        
        if(sel == '12'){ 
            this.time = this.time+' '+AMPM;
            this.time = this.convert24(this.time);
        }
        this.setTime(n);
        return true;
    }

    timeChange(){
        this.time = this.convert24(this.time);
    }

    convert24(time12h){ //converts from 12h to 24 hours
        const [time, modifier] = time12h.split(' ');
        let [hours, minutes] = time.split(':');

        if (hours === '12') {
            hours = '00';
        }

        if (modifier === 'PM') {
            hours = parseInt(hours, 10) + 12;
        }

        return `${hours}:${minutes}`;
    }

    items = []; 
    addMoreItems(){
        for(let i=0; i<=23; i++){
            if(i<10) this.items.push('0'+i.toString());
            else this.items.push(i.toString());
        }
    }

    items3 = [];
    addMoreItems3(){
        for(let i=1; i<=12; i++){
            if(i<10) this.items3.push('0'+i.toString());
            else this.items3.push(i.toString());
        }
    }

    items2 = [];
    addMoreItems2(){
        for(let i=0; i<=59; i++){
            if(i<10) this.items2.push('0'+i.toString());
            else this.items2.push(i.toString());
        }
    }

    onChangeHoursSlide(event, n) {
        var sel = (<HTMLInputElement>document.getElementById('selH')).value;
        var mod = (sel=='12') ? 13 : 24;
        var add = (sel=='12') ? 1 : 0;
        var hours: string = ((event.target.swiper.realIndex+add) % mod).toString();

        if(n==0 && this.h0 < 2){
            hours = (<HTMLInputElement>document.getElementById('24h'+n)).value;
            this.h0 = this.h0 + 1;
        }
        if(n==1 && this.h1 < 2){
            hours = (<HTMLInputElement>document.getElementById('24h'+n)).value;
            this.h1 = this.h1 + 1;
        }
        var minutes = (<HTMLInputElement>document.getElementById('24m'+n)).value;
        var AMPM = (<HTMLInputElement>document.getElementById('AMPM'+n)).value;
        if(hours.length==1) hours = '0'+hours;
        if(hours.length==2 && minutes.length==2) this.time = hours +':'+minutes;
        else if(hours.length==2) this.time = hours +':00';
        else if(minutes.length==2) this.time = '00:'+minutes;
        
        if(sel == '12'){ 
            this.time = this.time+' '+AMPM;
            this.time = this.convert24(this.time);
        }
        (<HTMLInputElement>document.getElementById('24h'+n)).value = hours;
        this.setTime(n);
    }

    onChangeMinutesSlide(event, n) {
        var sel = (<HTMLInputElement>document.getElementById('selH')).value;
        var hours = (<HTMLInputElement>document.getElementById('24h'+n)).value;
        var minutes: string = (event.target.swiper.realIndex % 60).toString();
        if(n==0 && this.m0 == true){
            minutes = (<HTMLInputElement>document.getElementById('24m'+n)).value;
            this.m0 = false;
        }
        if(n==1 && this.m1 == true){
            minutes = (<HTMLInputElement>document.getElementById('24m'+n)).value;
            this.m1 = false;
        }
        var AMPM = (<HTMLInputElement>document.getElementById('AMPM'+n)).value;
        if(minutes.length==1) minutes = '0'+minutes;
        if(hours.length==2 && minutes.length==2) this.time = hours +':'+minutes;
        else if(hours.length==2) this.time = hours +':00';
        else if(minutes.length==2) this.time = '00:'+minutes;
        
        if(sel == '12'){ 
            this.time = this.time+' '+AMPM;
            this.time = this.convert24(this.time);
        }
        (<HTMLInputElement>document.getElementById('24m'+n)).value = minutes;
        this.setTime(n);
    }

    setTime(n){
        //if(n==0) this.from = new Date(this.year0+','+this.month0+','+this.day0+','+this.time);
        //else if(n==1) this.to = new Date(this.year1+','+this.month1+','+this.day1+','+this.time);

        if(n==0){
            this.from = moment(this.from).set('hour', parseInt(this.time.split(":")[0]));
            this.from = moment(this.from).set('minute', parseInt(this.time.split(":")[1]));
        }else if(n==1){
            this.to = moment(this.to).set('hour', parseInt(this.time.split(":")[0]));
            this.to = moment(this.to).set('minute', parseInt(this.time.split(":")[1]));
        }
    }
}